// extracted by mini-css-extract-plugin
module.exports = {"root":"OrderPointsSuggestions_root__17Zj9","suggestionButton":"OrderPointsSuggestions_suggestionButton__2KteG"};